<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
    <nav
        class="sidebar fixed bottom-0 top-0 z-50 h-full min-h-screen w-[260px]
               border-e border-black/[0.08] dark:border-[#253b5c]
               transition-all duration-300">

        <div class="h-full bg-white dark:bg-[#0e1726] flex flex-col">

            <div class="flex items-center justify-between px-4 py-3 overflow-hidden">
                <a routerLink="/" class="main-logo flex shrink-0 items-center">
                    <img class="ml-[5px] w-8" src="/assets/images/sc.svg" alt="" />
                    <span
                        class="align-middle text-2xl font-semibold dark:text-white-light
                               w-[6.8rem] h-10 overflow-hidden lg:inline ltr:ml-1.5 rtl:mr-1.5">
                        <img class="w-full h-full object-cover !object-right-top"
                             src="/assets/images/logo.svg" alt="" />
                    </span>
                </a>

                <a href="javascript:;"
                   class="collapse-icon flex h-8 w-8 items-center rounded-full
                          transition hover:bg-gray-500/10 hover:text-primary
                          dark:text-white-light dark:hover:bg-dark-light/10 rtl:rotate-180"
                   (click)="storeData.dispatch({ type: 'toggleSidebar'})">
                    <icon-carets-down class="m-auto rotate-90" />
                </a>
            </div>

            <ng-scrollbar
                class="flex-1 relative"
                appearance="compact">

                <ul class="relative space-y-0.5 p-4 py-0 font-semibold">
                    <li class="nav-item">
                        <ul>
                            @for (item of navMenuList; track item.label) {
                            <li *appHasPermission="item.permission"
                                class="nav-item"
                                [ngClass]="{ 'accordion': item.isDropdown }">

                                @if (!item.isDropdown) {
                                <a [routerLink]="item.link"
                                   class="group"
                                   routerLinkActive="active"
                                   (click)="toggleMobileMenu()">
                                    <div class="flex items-center">
                                        <ng-container *ngComponentOutlet="item.icon"></ng-container>
                                        <span class="ltr:pl-3 rtl:pr-3">
                                            {{ item.label | translate }}
                                        </span>
                                    </div>
                                </a>
                                }

                                @if (item.isDropdown) {
                                <button type="button"
                                        class="nav-link group w-full"
                                        [ngClass]="{ 'active': activeDropdown.includes(item.label) }"
                                        (click)="toggleAccordion(item.label)">
                                    <div class="flex items-center">
                                        <ng-container *ngComponentOutlet="item.icon"></ng-container>
                                        <span class="ltr:pl-3 rtl:pr-3">
                                            {{ item.label | translate }}
                                        </span>
                                    </div>
                                    <ng-container *ngComponentOutlet="iconCaretDown"></ng-container>
                                </button>
                                }

                                @if (item.isDropdown) {
                                <div [@slideDownUp]="!activeDropdown.includes(item.label)"
                                     class="accordion-content">
                                    <ul class="sub-menu text-gray-500">
                                        @for (subItem of item.submenu; track subItem.label) {
                                        <li *appHasPermission="subItem.permission">
                                            <a [routerLink]="subItem.link"
                                               routerLinkActive="active"
                                               (click)="toggleMobileMenu()">
                                                {{ subItem.label | translate }}
                                            </a>
                                        </li>
                                        }
                                    </ul>
                                </div>
                                }
                            </li>
                            }
                        </ul>
                    </li>
                </ul>
            </ng-scrollbar>

            <div class="border-t dark:border-t-slate-600 border-slate-200 p-3 shrink-0">
                <button
                    (click)="handleLogout()"
                    class="w-full inline-flex items-center justify-center gap-2
                        py-2 hover:bg-grey-500/20 font-semibold">
                    <div class="flex items-center">
                        <icon-logout />
                        <span class="ltr:pl-3 rtl:pr-3 logout-text">
                            {{ 'logout' | translate }}
                        </span>
                    </div>
                </button>
            </div>
        </div>
    </nav>
</div>
